import { EditorController } from '@ibiz-template/runtime';
import { INumberRange } from '@ibiz/model-core';

/**
 * 数值范围编辑器控制器
 *
 * @export
 * @class NumberRangeEditorController
 * @extends {EditorController}
 */
export class NumberRangeEditorController extends EditorController<INumberRange> {}
